import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  mapLayout: {
    width:'100%',
    height:'100%',
    zIndex:50
  }
}));